import React, { createContext, useContext } from 'react';

const ClubExperienceContext = createContext({
  openModal: () => {},
});

export const useClubExperience = () => useContext(ClubExperienceContext);
export default ClubExperienceContext;
